import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [];
    static values = {
        idfield: String,
        enabled: Boolean,
        emptytext: String,
        columns: Array,
        items: Array
    }

    connect() {
        super.connect();
        this.element[this.identifier] = this;

        this.table = null;
        this.hiddenidfield = null;
        this.deletedidfield = null;
        this.thead = null;
        this.tbody = null;
        this.autoid = 1;
        this.deletedids = new Array();
        this.emptytextshown = false;

        this.log("values", [this.idfieldValue, this.columnsValue, this.itemsValue ]);
        this.render();
        this.itemsValue.forEach( (item) => {
            this.addItem( item )
        });
    }

    disconnect() {
        this.element[this.identifier] = null;
        super.disconnect();
    }

    render() {

        this.table = document.createElement( 'TABLE' );
        this.table.style.width= '100%';
        this.thead = document.createElement( 'THEAD' );
        this.tbody = document.createElement( 'TBODY' );

        var tr = document.createElement('TR');
        for( var i=0; i<this.columnsValue.length; i++ ) {
            var column = this.columnsValue[i];
            var th = document.createElement('TH');
            if( column.render != 'hidden' ) {
                th.appendChild( document.createTextNode( column.label ));
                if( column.width != undefined ) {
                    th.style.width = column.width;
                }
                tr.appendChild( th );
            }
        }
        this.thead.appendChild( tr );

        // add the table parts to the table
        this.table.appendChild( this.thead );
        this.table.appendChild( this.tbody );

        if( this.hiddenidfield == null ) {
            this.hiddenidfield = document.createElement('INPUT');
            this.hiddenidfield.type = "hidden";
            this.hiddenidfield.name = this.idfieldValue;
            this.hiddenidfield.value = "";

            this.element.appendChild( this.hiddenidfield );

            this.deletedidfield = document.createElement('INPUT');
            this.deletedidfield.type = "hidden";
            this.deletedidfield.name = this.idfieldValue+"_deleted";
            this.deletedidfield.value = "";
            this.element.appendChild( this.deletedidfield );
        }

        // finally add the constructed table to the container
        // that is preserved for this table
        this.element.appendChild( this.table );

        if( this.emptytextValue != "" ) {
            var tr = document.createElement('TR');
            var td = document.createElement('TD');
            td.colSpan = this.columnsValue.length;
            td.appendChild( document.createTextNode( this.emptytextValue ));
            tr.appendChild( td );
            this.tbody.appendChild( tr );
            this.emptytextshown = true;
        }
    }

    moveItem(link,dir) {

        var tr = link.parentNode.parentNode;

        var r1 = tr;
        var r2;
        if( dir == +1 ) {
            r2 = r1.nextSibling;
        } else if( dir == -1 ) {
            r2 = r1.previousSibling;
        }

        if( r2 == null ) return;

        if( dir == +1 ) {
            var beforeNode = r2.nextSibling;

            this.tbody.removeChild(r1);
            this.tbody.removeChild(r2);

            this.tbody.insertBefore(r2,beforeNode);
            this.tbody.insertBefore(r1,beforeNode);
        } else if( dir == -1 ) {
            var beforeNode = r1.nextSibling;

            this.tbody.removeChild(r1);
            this.tbody.removeChild(r2);

            this.tbody.insertBefore(r1,beforeNode);
            this.tbody.insertBefore(r2,beforeNode);
        }
        this.updateHiddenFields();
        this.onChange();
    }

    delItem(link) {
        var tr = link.parentNode.parentNode;
        this.deletedids.push(tr.idvalue);
        this.tbody.removeChild(tr);
        this.updateHiddenFields();
        this.onChange();
    }

    addItem( values ) {

        var idvalue;
        if( this.idfieldValue ) {
            idvalue =values[ this.idfieldValue ];

            // if no idfield is specified then use
            // an autoincrement field
            if( typeof idvalue == 'undefined' ) {
                idvalue = this.autoid++;
            } else {
                // if there is an idvalue then make sure that next
                // autoid is higher than this one
                if( idvalue >= this.autoid ) {
                    this.autoid = idvalue;
                    this.autoid++;
                }
            }

            for( var i=0; i<this.tbody.rows.length; i++ ) {
                if( this.tbody.rows[i].idvalue == idvalue ) {
                    return;
                }
            }
        }

        var tr = document.createElement('TR');
        for( var i=0; i<this.columnsValue.length; i++ ) {
            var column = this.columnsValue[i];
            var content = new Array;
            switch( column.render ) {
                case 'hidden':
                    var text = document.createElement('INPUT');
                    text.type = "hidden";
                    text.name = column.field+'_'+idvalue;
                    if( values[ column.field ] == undefined ) {
                        text.value = column.defaultvalue;
                    } else {
                        text.value = values[ column.field ];
                    }
                    tr.appendChild( text );
                    break;

                case 'move':
                    var uplink = document.createElement('A');
                    var upimage = document.createElement('IMG');
                    upimage.src = "uporder.gif";
                    upimage.border = 0;
                    upimage.alt = "Move Up";
                    uplink.href="#";
                    uplink.onclick = function() {
                        this.moveItem(uolink,-1);
                        return false;
                    }.bind(this);
                    uplink.appendChild( upimage );
                    content.push( uplink );

                    var downlink = document.createElement('A');
                    var downimage = document.createElement('IMG');
                    downimage.src = "downorder.gif";
                    downimage.border = 0;
                    downimage.alt = "Move Down";
                    downlink.href="#";
                    downlink.onclick = function() {
                        this.moveItem(downlink, +1);
                        return false;
                    }.bind(this);
                    downlink.appendChild( downimage );
                    content.push( downlink );

                    break;

                case 'delete':
                    var trashlink = document.createElement('A');
                    var trashimage = document.createElement('IMG');
                    trashimage.src = "/images/delete.gif";
                    trashimage.border = 0;
                    trashimage.alt = "Delete";
                    trashlink.href="#";
                    trashlink.onclick = function() {
                        this.delItem(trashlink);
                        return false;
                    }.bind(this);
                    trashlink.appendChild( trashimage );
                    content.push( trashlink );

                    break;

                case 'image':
                    var text = values[ column.field ];
                    if( text == undefined ) {
                        text = column.defaultvalue;
                        if( text == undefined ) {
                            text = "";
                        }
                    }
                    var trashimage = document.createElement('IMG');
                    trashimage.src = text;
                    trashimage.border = 0;
                    content.push( trashimage );
                    break;

                case 'static':
                    var text = values[ column.field ];
                    if( text == undefined ) {
                        text = column.defaultvalue;
                        if( text == undefined ) {
                            text = "";
                        }
                    }
                    var hidden = document.createElement('INPUT');
                    hidden.type = "hidden";
                    hidden.name = column.field+'_'+idvalue;
                    if( values[ column.field ] == undefined ) {
                        hidden.value = column.defaultvalue;
                    } else {
                        hidden.value = values[ column.field ];
                    }
                    content.push( hidden );

                    if( column.linkto != undefined ) {
                        var a = document.createElement('A');
                        a.href=eval(column.linkto);
                        a.appendChild(document.createTextNode( text ));
                        content.push( a );
                    } else {
                        var e = document.createElement('SPAN');
                        e.innerHTML=text;
                        content.push( e );
                    }

                    break;

                case 'radio':
                    var radio = document.createElement('INPUT');
                    radio.type = "radio";
                    radio.name = column.field;
                    radio.value = idvalue;
                    radio.disabled = (this.enabledValue !=1 );
                    radio.defaultChecked = ( idvalue == values[ column.field ] );

                    content.push( radio );
                    break;

                case 'checkbox':
                    var checkbox = document.createElement('INPUT');
                    checkbox.type = "checkbox";
                    checkbox.name = column.field+'_'+idvalue;
                    checkbox.disabled = (this.enabledValue !=1 );

                    if( column.checkedvalue == undefined ) {
                        column.checkedvalue = 1;
                    }

                    checkbox.value = column.checkedvalue;

                    var v;
                    if( values[ column.field ] == undefined ) {
                        v = column.defaultvalue;
                    } else {
                        v = values[ column.field ];
                    }
                    checkbox.defaultChecked = (v == column.checkedvalue);
                    content.push( checkbox );
                    break;

                case 'singleline':
                    var text = document.createElement('INPUT');
                    text.type = "text";
                    text.name = column.field+'_'+idvalue;
                    text.disabled = (this.enabledValue !=1 );
                    if( values[ column.field ] == undefined ) {
                        text.value = column.defaultvalue;
                    } else {
                        text.value = values[ column.field ];
                    }
                    content.push( text );
                    break;

            }

            if( content.length ) {
                var td = document.createElement('TD');
                if( column.align ) {
                    td.align = column.align;
                }
                for(var ii=0;ii<content.length;ii++) {
                    td.appendChild( content[ii] );
                }
                tr.appendChild( td );
            }
        }
        // for the idfield we only have one single 
        // field 
        tr.idvalue = idvalue;

        if( this.emptytextshown ) {
            this.tbody.removeChild( this.tbody.firstChild );
            this.emptytextshown = false;
        }
        this.tbody.appendChild( tr );

        this.updateHiddenFields();
        this.onChange();
    }

    updateHiddenFields() {
        var idvalues = new Array();
        for( var i=0; i<this.tbody.rows.length; i++ ) {
            idvalues.push( this.tbody.rows[i].idvalue );
        }
        this.hiddenidfield.value = idvalues.join(',');
        this.deletedidfield.value = this.deletedids.join(',');
    }

    onChange() {

    }

}
